package com.essntl.core.settings.domain.model.feature

data class FeatureModel(
    val id: String,
    val name: String,
    val createdAt: String,
)